export const checkValidData = (email, password, Name) => {
  const isEmailValid = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(
    email
  );
  const isPasswordValid =
    /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(password);
  const isNameValid = /^[a-zA-Z ]{2,30}$/.test(Name);

  if (!isEmailValid) return "Email Is not Valid";
  if (!isPasswordValid) return "PassWord Is not Valid";
  if (!isNameValid) return "Name Is not Valid";

  return null;
};
